:host{border:1px solid #e9ebed;background-color:#fff;display:block;margin-bottom:1em;border-color:#e9ebed;word-wrap:break-word;padding:0}:host img{max-width:100%}
/*# sourceMappingURL=info.component.css.map */
